import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar las traducciones
import enTranslation from './locales/en.json';
import esTranslation from './locales/es.json';

// Merge español en inglés como fallback
const mergedEn = { ...esTranslation, ...enTranslation };

const isBrowser = typeof window !== 'undefined';

let chain = i18n;
// El LanguageDetector lee navigator/localStorage: solo en el navegador. En Node (SSR del
// build) se omite y se fuerza 'es', evitando que rompa al importar <App/>.
if (isBrowser) chain = chain.use(LanguageDetector);

chain
  .use(initReactI18next) // Pasa i18next a react-i18next
  .init({
    resources: {
      en: { translation: mergedEn },
      es: { translation: esTranslation },
    },
    fallbackLng: 'es', // Idioma por defecto si no se detecta el idioma del navegador
    lng: isBrowser ? undefined : 'es', // SSR: idioma determinista
    interpolation: {
      escapeValue: false, // React ya maneja el escape de texto
    },
    pluralSeparator: '_', // Separador para claves de pluralización
    detection: {
      // Opciones de detección
      order: ['navigator'], // Detecta el idioma a través del navegador
      caches: ['localStorage'], // Guarda el idioma en el almacenamiento local
    },
  });

export default i18n;
